import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import EventsPage from '../events/events.page';

const HomePage = observer(() => {
  return <EventsPage />;
});

export default HomePage;
